import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

console.log('Initializing Supabase client with URL:', supabaseUrl);
console.log('Supabase anon key exists:', !!supabaseAnonKey);

// Validate environment variables
if (!supabaseUrl) {
  console.error('REACT_APP_SUPABASE_URL is not defined!');
  throw new Error('REACT_APP_SUPABASE_URL is not defined');
}

if (!supabaseAnonKey) {
  console.error('REACT_APP_SUPABASE_ANON_KEY is not defined!');
  throw new Error('REACT_APP_SUPABASE_ANON_KEY is not defined');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'code-splash-auth',
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
  global: {
    headers: {
      'X-Client-Info': 'code-splash-website'
    }
  }
});

// Test the connection
supabase.auth.getSession().then(({ data, error }) => {
  if (error) {
    console.error('Error testing Supabase connection:', error);
  } else {
    console.log('Supabase connection test successful');
  }
}); 